/* Events calendar controller.
   - Default "Cards" view is rendered server-side (Liquid) and shown by default.
   - Month / Week / List views are powered by FullCalendar (global bundle),
     initialised lazily the first time the visitor switches to a calendar view.
   - Events come from a JSON blob rendered server-side (works behind the
     storefront password and in the theme editor, no client fetch). */
(function () {
  function init(root) {
    var calendarEl = root.querySelector(".ec-calendar-mount");
    var cardsEl = root.querySelector("[data-ec-cards]");
    var calWrap = root.querySelector(".ec-calendar");
    var dataNode = root.querySelector("[data-ec-events]");
    var tooltip = root.querySelector(".ec-tooltip");
    var locale = root.getAttribute("data-locale") || "de";
    var tz = root.getAttribute("data-timezone") || "Europe/Vienna";

    var I18N = {
      de: { today: "Heute", month: "Monat", week: "Woche", day: "Tag", list: "Liste", allDay: "Ganztägig", noEvents: "Keine Events in diesem Zeitraum.", locale: "de-DE", goto: "Zum Event" },
      en: { today: "Today", month: "Month", week: "Week", day: "Day", list: "List", allDay: "All day", noEvents: "No events to display.", locale: "en-GB", goto: "View event" },
      fr: { today: "Aujourd'hui", month: "Mois", week: "Semaine", day: "Jour", list: "Liste", allDay: "Journée", noEvents: "Aucun événement à afficher.", locale: "fr-FR", goto: "Voir l'événement" },
      it: { today: "Oggi", month: "Mese", week: "Settimana", day: "Giorno", list: "Lista", allDay: "Tutto il giorno", noEvents: "Nessun evento da mostrare.", locale: "it-IT", goto: "Vedi evento" },
      cs: { today: "Dnes", month: "Měsíc", week: "Týden", day: "Den", list: "Seznam", allDay: "Celý den", noEvents: "Žádné události k zobrazení.", locale: "cs-CZ", goto: "Zobrazit událost" },
      sl: { today: "Danes", month: "Mesec", week: "Teden", day: "Dan", list: "Seznam", allDay: "Ves dan", noEvents: "Ni dogodkov za prikaz.", locale: "sl-SI", goto: "Ogled dogodka" }
    };
    var t = I18N[locale] || I18N.de;

    var PALETTE = ["#0c2340", "#8d734a", "#2ba0af", "#534369", "#718b49", "#d65f00"];
    var colorMap = {};
    var colorIdx = 0;
    function colorFor(cat) {
      if (!cat) return PALETTE[0];
      if (!(cat in colorMap)) { colorMap[cat] = PALETTE[colorIdx % PALETTE.length]; colorIdx++; }
      return colorMap[cat];
    }

    function loadEvents() {
      if (!dataNode) return [];
      try { return JSON.parse(dataNode.textContent.trim()) || []; }
      catch (e) { console.error("Events calendar: bad JSON", e); return []; }
    }

    // FullCalendar all-day "end" is exclusive; push one day so the last day is spanned.
    function addOneDay(dateStr) {
      if (!dateStr) return null;
      var d = new Date(dateStr + "T12:00:00");
      if (isNaN(d.getTime())) return null;
      d.setDate(d.getDate() + 1);
      return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
    }

    function formatDateShort(dateStr) {
      if (!dateStr) return "";
      var d = new Date(dateStr + "T12:00:00");
      if (isNaN(d.getTime())) return dateStr;
      return d.toLocaleDateString(t.locale, { day: "numeric", month: "short", year: "numeric" });
    }

    function toCalEvent(e) {
      var color = colorFor(e.category);
      return {
        title: e.title,
        start: e.start,
        end: addOneDay(e.end || e.start),
        backgroundColor: color,
        borderColor: color,
        textColor: "#ffffff",
        display: "block",
        url: e.url || "",
        extendedProps: { image: e.image || null, price: e.price || "", rawStart: e.start, rawEnd: e.end || null }
      };
    }

    var allEvents = loadEvents().map(toCalEvent);
    var calendar = null;

    /* ---- Tooltip ---- */
    var hideTimer = null, showTimer = null;
    function canHover() { return window.matchMedia("(hover: hover) and (pointer: fine)").matches; }
    function q(id) { return root.querySelector(id); }

    function positionTooltip(anchorEl) {
      var rect = anchorEl.getBoundingClientRect();
      var tw = 280, tipHeight = tooltip.offsetHeight || 320, pad = 8;
      var left = rect.left + rect.width / 2 - tw / 2;
      if (left < pad) left = pad;
      if (left + tw > window.innerWidth - pad) left = window.innerWidth - pad - tw;
      var top, spaceBelow = window.innerHeight - rect.bottom;
      if (spaceBelow >= tipHeight + pad) top = rect.bottom + pad;
      else { top = rect.top - tipHeight - pad; if (top < pad) top = pad; }
      tooltip.style.left = left + "px";
      tooltip.style.top = top + "px";
    }

    function showTooltip(fcEvent, anchorEl) {
      if (!tooltip) return;
      clearTimeout(hideTimer); clearTimeout(showTimer);
      showTimer = setTimeout(function () {
        var p = fcEvent.extendedProps;
        q(".ec-tip-title").textContent = fcEvent.title;
        var startStr = formatDateShort(p.rawStart);
        var endStr = p.rawEnd ? formatDateShort(p.rawEnd) : "";
        q(".ec-tip-dates span").textContent = endStr && endStr !== startStr ? startStr + " — " + endStr : startStr;
        var priceEl = q(".ec-tip-price");
        if (p.price) { priceEl.textContent = p.price; priceEl.style.display = "block"; } else { priceEl.style.display = "none"; }
        var img = q(".ec-tip-img");
        if (p.image) { img.src = p.image; img.alt = fcEvent.title; img.style.display = "block"; } else { img.style.display = "none"; }
        q(".ec-tip-btn").href = fcEvent.url || "#";
        positionTooltip(anchorEl);
        tooltip.classList.add("ec-tooltip-visible");
      }, 180);
    }

    function scheduleHide() {
      clearTimeout(showTimer);
      hideTimer = setTimeout(function () { tooltip.classList.remove("ec-tooltip-visible"); }, 250);
    }

    if (tooltip) {
      tooltip.addEventListener("mouseenter", function () { clearTimeout(hideTimer); });
      tooltip.addEventListener("mouseleave", scheduleHide);
    }

    function registerLocale() {
      if (window.FullCalendar && FullCalendar.globalLocales) {
        FullCalendar.globalLocales.push({
          code: locale,
          week: { dow: 1, doy: 4 },
          buttonText: { today: t.today, month: t.month, week: t.week, day: t.day, list: t.list },
          allDayText: t.allDay,
          noEventsText: t.noEvents
        });
      }
    }

    function initCalendar(view) {
      if (!window.FullCalendar) { console.error("FullCalendar not loaded"); return; }
      registerLocale();
      calendar = new FullCalendar.Calendar(calendarEl, {
        locale: locale,
        timeZone: tz,
        initialView: view,
        firstDay: 1,
        height: "auto",
        weekNumbers: false,
        headerToolbar: { left: "prev,next today", center: "title", right: "" },
        events: allEvents,
        displayEventTime: false,
        eventDisplay: "block",
        dayMaxEventRows: 4,
        moreLinkClick: "popover",
        eventClick: function (info) {
          info.jsEvent.preventDefault();
          if (info.event.url) window.location.href = info.event.url;
        },
        eventMouseEnter: function (info) { if (canHover()) showTooltip(info.event, info.el); },
        eventMouseLeave: function () { if (canHover()) scheduleHide(); },
        eventDidMount: function (info) { info.el.title = ""; }
      });
      calendar.render();
    }

    /* ---- View toggle ---- */
    var buttons = root.querySelectorAll("[data-ec-view]");
    function setActive(view) {
      buttons.forEach(function (b) { b.classList.toggle("is-active", b.getAttribute("data-ec-view") === view); });
    }
    function showCards() {
      if (cardsEl) cardsEl.style.display = "";
      if (calWrap) calWrap.style.display = "none";
      setActive("cards");
    }
    function showCalendar(fcView) {
      if (cardsEl) cardsEl.style.display = "none";
      if (calWrap) calWrap.style.display = "";
      if (!calendar) initCalendar(fcView);
      else { calendar.changeView(fcView); calendar.updateSize(); }
      setActive(fcView);
    }
    buttons.forEach(function (b) {
      b.addEventListener("click", function () {
        var v = b.getAttribute("data-ec-view");
        if (v === "cards") showCards();
        else showCalendar(v);
      });
    });

    // Default view = cards (already visible in markup)
    setActive("cards");
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-events-calendar]").forEach(init);
  });
})();
